<template>
  <div class="wrapper">
    <h2>Upload SSH Key</h2>

    <el-card>
      <div id="account-ssh">
        <h3>
          Secure your applications access by establishing encrypted connections
        </h3>
        <el-card shadow="hover">
          <el-row type="flex" justify="center" align="middle" :gutter="35">
            <el-col :span="16">
              <el-upload
                :action="action"
                :headers="headers"
                :on-success="update"
                drag
              >
                <i class="el-icon-upload" />
                <div class="el-upload__text">
                  Paste your own ssh <strong>public key</strong> here or <em>click to upload</em>
                </div>
              </el-upload>
            </el-col>

            <el-col :span="8" align="center">
              <el-button
                type="primary"
                icon="mdi mdi-key-variant"
                plain
                @click="showGenerate = true"
              >
                Generate a key pair
              </el-button>
            </el-col>
          </el-row>

          <el-alert v-if="user.ssh" type="success" :closable="false">
            <div slot="title">
              <i class="mdi mdi-check-decagram" />
              {{ user.sign }}
            </div>

            <el-button type="text" icon="el-icon-delete" @click.prevent="removeKey" />
          </el-alert>
        </el-card>

        <GenerateKey :visible.sync="showGenerate" />
      </div>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import { mapState, mapGetters } from 'vuex'
import GenerateKey from '../components/Account/GenerateKey'

export default {
  components: {
    GenerateKey
  },
  data () {
    return {
      action: axios.defaults.baseURL + 'engine/account',
      headers: Vue.api.defaults.headers.common,
      showGenerate: false,
      form: {
        key: null
      }
    }
  },
  computed: {
    ...mapState(['client', 'user']),
    ...mapGetters(['permission'])
  },
  methods: {
    update (data) {
      this.$store.commit('init', { user: data })
    },
    removeKey () {
      this.$store.dispatch('updateUser', { ssh: null, sign: null })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../theme";

  h3 {
    border-bottom: 1px solid $--border-color-base;
    margin-bottom: 24px;
    padding-bottom: 24px;
  }
</style>

<style lang="scss">
  @import "../theme";

  #account-ssh {
    .el-card__body {
      padding: 0;
      font-size: 14px;

      > .el-alert {
        -moz-border-radius-topleft: 0;
        -moz-border-radius-topright: 0;
        -webkit-border-top-left-radius: 0;
        -webkit-border-top-right-radius: 0;
        border-top-left-radius: 0;
        border-top-right-radius: 0;

        .el-alert__description {
          position: absolute;
          right: 20px;
          top: -3px;
          margin: 0;

          .el-icon-delete {
            color: #444;
          }
        }
      }

      .el-row {
        padding: 20px;
      }

      h4 {
        margin: 0 0 10px;
        font-size: 16px;
      }

      .small {
        font-size: 12px;
      }
    }

    .el-upload, .el-upload-dragger {
      width: 100% !important;
    }
    .el-upload-dragger {
      height: auto;
      padding: 10px;

      .el-icon-upload {
        font-size: 40px;
        color: $--color-primary;
        margin: 0 0 10px;
      }
    }
  }
</style>
